import React from "react";
import { List, Rate } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { NavLink } from "react-router-dom";

function DashboardList({ data, title }) {
  return (
    <div className="wrapper">
      <header>
        <NavLink to={"/" + title.toLowerCase()}>
          <h2>{title}</h2>
        </NavLink>
        <EllipsisOutlined />
      </header>
      <List
        className="list"
        itemLayout="horizontal"
        dataSource={data}
        renderItem={(item, index) => (
          <List.Item className="list-item">
            {item.scenarios !== null ? (
              <List.Item.Meta
                title={item.title !== "" ? item.title : "Noname"}
                description={
                  "Player Count: " +
                  item.playerCount +
                  " | AVG Time: " +
                  Math.round(item.avarageDuration) +
                  " | MIN Time: " +
                  item.minDuration +
                  " | MAX Time: " +
                  item.maxDuration
                }
              />
            ) : (
              <List.Item.Meta
                title={item.title}
                description={"Scenario-" + item.id}
              ></List.Item.Meta>
            )}
            <div>
              <Rate
                disabled
                allowHalf
                count={3}
                defaultValue={item.avarageScore}
              />

              <div>Score:{item.scoreNumber.toFixed(0)}</div>
            </div>
          </List.Item>
        )}
      />
    </div>
  );
}

export default DashboardList;
